<template>
  <div ref="tableScollRef">
    <slot name="table"></slot>
  </div>
</template>

<script>
import { defineComponent, nextTick, onMounted, ref } from "vue";

export default defineComponent({
  props: {
    scrollConfig: {
      horizon: Boolean,
      vertical: Boolean,
    },
  },
  setup() {
    const tableScollRef = ref();
    const tableScrollWidth = ref(null);
    onMounted(() => {
      nextTick(() => {
        const { left, top, bottom, right } =
          tableScollRef.value.getBoundingClientRect();

        tableScrollWidth.value = right - left - 20;
      });
    });

    return {
      tableScollRef,
      tableScrollWidth,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
